import type React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProfile } from '@/hooks/use-profile'

export interface OrgSwitcherProps {
  readonly currentSlug: string
}

export function OrgSwitcher({ currentSlug }: OrgSwitcherProps): React.ReactElement {
  const { organizations } = useProfile()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const currentOrg = organizations.find((o) => o.slug === currentSlug)

  const handleSwitch = (slug: string): void => {
    setOpen(false)
    navigate(`/${slug}/plans`)
  }

  return (
    <div className="relative" data-testid="org-switcher">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium hover:bg-neutral-100"
        data-testid="org-switcher-trigger"
      >
        {currentOrg?.name ?? currentSlug}
        <span className="text-neutral-400">&#9662;</span>
      </button>

      {open && (
        <div className="absolute left-0 top-full z-50 mt-1 w-56 rounded-md border border-neutral-200 bg-white py-1 shadow-lg">
          {organizations.map((org) => (
            <button
              key={org.id}
              type="button"
              onClick={() => handleSwitch(org.slug)}
              className={`block w-full px-4 py-2 text-left text-sm hover:bg-neutral-50 ${
                org.slug === currentSlug ? 'font-medium text-brand-600' : ''
              }`}
            >
              {org.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
